/**
 * A product barcode as the warehouse registers it. Most are 8-14 digit EAN/UPC codes, but some printed
 * codes carry letters (e.g. "PL…"), and the product master stores whatever it is sent after trimming, so
 * the rule here is the admin's own: upper-case letters, digits and hyphens, up to 64 characters.
 */
const PRODUCT_BARCODE = /^[A-Z0-9-]{1,64}$/;

export const PRODUCT_BARCODE_HINT = 'Letters, digits or - (up to 64)';

export const PRODUCT_BARCODE_ERROR = 'A barcode must be 1-64 letters, digits, or hyphens (no spaces).';

/** The scan lookup matches a barcode exactly, so it is stored in one spelling: trimmed and upper case. */
export const normalizeProductBarcode = (text: string): string => text.trim().toUpperCase();

/** Answers on a code already normalised. */
export const isValidProductBarcode = (code: string): boolean => PRODUCT_BARCODE.test(code);

export const isInvalidEditedProductBarcode = (
  barcode: string | undefined,
  originalBarcode: string | undefined,
): boolean => barcode !== originalBarcode && barcode !== undefined && barcode !== '' && !isValidProductBarcode(barcode);
